import React from 'react'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import { AppModal } from '../../../../../../generic/ui/Modal'
import { Surface, ScrollArea } from '../../../../../../generic/ui/Surface'
import ScanBar from '../../../../../../generic/ui/Input/ScanBar'
import Image from '../../../../../../generic/assets/warhouseWork.webp'
import KnisaActionDock from '../../../knisot/Create/Components/KnisaActionDock'
import useProductLocation from '../hooks/useProductLocation'
import ProductLocationPageLayout from './ProductLocationPageLayout'
import ProductLocationRow from './ProductLocationRow'
import ScannedLocationHeader from './ScannedLocationHeader'
import EditBalanceModal from './EditBalanceModal'

const ProductLocationMain = () => {
  const [t] = useTranslation('knisa')
  const {
    scannedPallet,
    scannedLocation,
    locationCode,
    scanStage,
    scanValue,
    setScanValue,
    handleScan,
    clearScannedDataPallet,
    clearScannedDataLocation,
    handleBoundPalletToLocation,
    canBound,
    isOpenModal,
    openModal,
    closeModal,
    balanceModalProps,
  } = useProductLocation()

  return (
    <ProductLocationPageLayout title='איתור למשטח'>
      {isOpenModal && balanceModalProps && (
        <AppModal
          title={t('knisa_create_modal_product_balance')}
          Children={EditBalanceModal}
          childrenProps={balanceModalProps}
          controlFunc={closeModal}
          size='sm'
        />
      )}

      <Surface>
        <Scroll>
          {/* Карточка книсы уезжает вверх вместе со списком, ScanBar остаётся sticky */}
          {scannedPallet && (
            <ProductLocationRow
              item={scannedPallet}
              onEdit={openModal}
              onClear={clearScannedDataPallet}
            />
          )}
          <StickyScan>
            {/* Железный сканер слушает хук (по стадии), здесь только ручной ввод */}
            <ScanBar
              value={scanValue}
              onChange={setScanValue}
              onScan={handleScan}
              captureGlobalScans={false}
              placeholder={scanStage === 'entry' ? 'ברקוד כניסה' : 'ברקוד איתור'}
            />
          </StickyScan>

          {scannedLocation ? (
            <LocationBlock>
              <ScannedLocationHeader code={locationCode.trim()} onClear={clearScannedDataLocation} />
              {scannedLocation.entryLine.length > 0 ? (
                scannedLocation.entryLine.map((item, i) => (
                  <ProductLocationRow
                    key={`${item.ProductID}-${i}`}
                    item={item}
                    isLast={i === scannedLocation.entryLine.length - 1}
                  />
                ))
              ) : (
                <EmptyText>אין פריטים במיקום זה</EmptyText>
              )}
            </LocationBlock>
          ) : (
            <EmptyState>
              <img src={Image} alt='' />
            </EmptyState>
          )}
        </Scroll>
      </Surface>

      {canBound && (
        <KnisaActionDock
          onCreate={handleBoundPalletToLocation}
          canCreate
          createLabel='עדכן איתור'
          hideCreateIcon
        />
      )}
    </ProductLocationPageLayout>
  )
}

export default ProductLocationMain

// Запас снизу, чтобы плавающий док не перекрывал последние строки
const Scroll = styled(ScrollArea)`
  padding-bottom: calc(4.75rem + env(safe-area-inset-bottom, 0px));
`

const StickyScan = styled.div`
  position: sticky;
  top: 0;
  z-index: 1;
  padding: 0.625rem 0.875rem;
  background: ${({ theme }) => theme.colors.surface};
  border-bottom: 1px solid ${({ theme }) => theme.colors.line2};

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    padding: 0.5rem;
  }
`

// Найденная ячейка отдельной карточкой, чтобы не сливалась с книсой и сканером
const LocationBlock = styled.div`
  margin: 0.625rem 0.875rem;
  border: 1px solid ${({ theme }) => theme.colors.line};
  border-radius: ${({ theme }) => theme.radii.md};
  background: ${({ theme }) => theme.colors.surface};
  overflow: hidden;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    margin: 0.5rem;
  }
`

const EmptyState = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2rem;

  img {
    width: 100%;
    max-width: 20rem;
    height: auto;
  }
`

const EmptyText = styled.div`
  padding: 1.5rem 0.875rem;
  text-align: center;
  font-family: ${({ theme }) => theme.fonts.sans};
  font-size: ${({ theme }) => theme.text.md};
  color: ${({ theme }) => theme.colors.ink3};

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    font-size: ${({ theme }) => theme.textMobile.md};
  }
`
